export default {
  button: {
    borderRight: '1px solid #fff'
  },
  dropdown: {
    position: 'relative',
    top: 1,
    backgroundColor: 'white',
    height: 38,
    paddingLeft: 20,
    border: '3px solid #0275d8',
    color: '#0275d8',
    margin: '0',
    WebkitAppearance: 'none',
    padding: '0 10px 0 15px'
  },
  input: {
    position: 'relative',
    top: 1,
    backgroundColor: 'white',
    borderRadius: 0,
    height: 16,
    margin: 0,
    color: '#0275d8',
    border: '3px solid #0275d8'
  },
  toolbar: {
    position: 'fixed',
    top: 0,
    left: '80px',
    minWidth: '95%',
    zIndex: 5,
    display: 'none'
  },
  overlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#222',
    color: '#fff',
    borderRadius: 3,
    opacity: '.82',
    fontWeight: 300,
    fontSize: '2.15rem',
    cursor: 'pointer',
    display: 'none'
  }
}
